import request from '@/utils/request'
import { getToken, getSign, getBaseURL } from '@/utils/auth'

export function login(mobile, code, sms_token) {
    return request({
        url: '/web/user/login',
        method: 'post',
        data: {
            mobile: mobile,
            sms_code: code,
            sms_token: sms_token
        }
    })
}
export function sclLogin(stu_no, password) {
    return request({
        url: 'web/user/loginByBusiness',
        method: 'post',
        data: {
            stu_no: stu_no,
            password: password
        }
    })
}
export function sendSms(mobile, sms_token) {
    return request({
        url: '/web/user/send_sms_ajax',
        method: 'post',
        data: {
            mobile: mobile,
            sms_token: sms_token
        }
    })
}
export function loginOut() {
    return request({
        url: '/web/other/login_out',
        method: 'post',
        data: {}
    })
}
export function headImgUpload(file) {
    return request({
        url: '/web/other/head_img_upload',
        method: 'post',
        data: {
            file: file
        },
    })
}
export function personInfo() {
    return request({
        url: '/web/other/person_info',
        method: 'post',
        data: {}
    })
}
export function teamInfo() {
    return request({
        url: '/web/other/team_info',
        method: 'post',
        data: {}
    })
}
export function teamInfoEdit(score, local_type_id, local_batch_type, year, subject_name) {
    return request({
        url: '/web/other/team_info_edit',
        method: 'post',
        data: {
            score: score,
            local_type_id: local_type_id,
            local_batch_type: local_batch_type,
            area: localStorage.getItem('area'),
            year: year,
            subject_name: subject_name
        }
    })
}
export function teamInfoAdd(score, local_type_id, local_batch_type, section_line) {
    return request({
        url: '/web/other/team_info_add',
        method: 'post',
        data: {
            score: score,
            local_type_id: local_type_id,
            local_batch_type: local_batch_type,
            section_line: section_line
        }
    })
}
export function getHistoryRecordList() {
    return request({
        url: '/web/psytest/record_list',
        method: 'post',
        data: {
        }
    })
}
export function getHistoryRecordDetail(form) {
    const data = {
        psr_id: form.psr_id,
        test_id: form.test_id
    }
    data['token'] = getToken()
    data['sign'] = getSign(data)
    let url = getBaseURL() + '/web/psytest/result?'
    for (const i in data) {
        if (i === 'app_secret') {
            continue
        }
        url += i + '=' + data[i] + '&'
    }
    return url
}
export function downloadHistoryRecordDetail(form) {
    return request({
        url: '/web/psytest/download_pdf',
        method: 'post',
        data: {
            psr_id: form.psr_id,
            test_id: form.test_id
        }
    })
}
export function regist(user_name, mobile, sms_code, sms_token, password) {
    return request({
        url: '/web/User/regist',
        method: 'post',
        data: {
            user_name: user_name,
            mobile: mobile,
            sms_code: sms_code,
            sms_token: sms_token,
            password: password
        }
    })
}
export function sendRegistSms(mobile, sms_token) {
    return request({
        url: '/web/User/sendRegistSms',
        method: 'post',
        data: {
            mobile: mobile,
            sms_token: sms_token
        }
    })
}
export function forgetPassword(mobile, sms_code, sms_token, new_password) {
    return request({
        url: '/web/User/forgetPassword',
        method: 'post',
        data: {
            mobile: mobile,
            sms_code: sms_code,
            sms_token: sms_token,
            new_password: new_password
        }
    })
}
export function sendForgetSms(mobile, sms_token) {
    return request({
        url: '/web/User/sendForgetSms',
        method: 'post',
        data: {
            mobile: mobile,
            sms_token: sms_token
        }
    })
}
export function loginPassword(user_name, password, geetest_challenge, geetest_validate, geetest_seccode) {
    return request({
        url: '/web/User/loginPassword',
        method: 'post',
        data: {
            user_name: user_name,
            password: password,
            geetest_challenge: geetest_challenge,
            geetest_validate: geetest_validate,
            geetest_seccode: geetest_seccode
        }
    })
}
export function geetest() {
    return request({
        url: '/web/User/geetest',
        method: 'post',
        data: {}
    })
}
export function personInfoEdit(mobile, form) {
    return request({
        url: '/web/other/person_info_edit',
        method: 'post',
        data: {
            mobile: mobile,
            nickname: form.nickname,
            sex: form.sex,
            nation: form.nation,
            birthdate: form.birthdate,
            graduate_school: form.graduate_school,
            subject: form.subject,
            is_current: form.is_current,
            height: form.height,
            weight: form.weight,
            naked_vision: JSON.stringify(form.naked_vision),
            corrected_vision: JSON.stringify(form.corrected_vision),
            glasses_degree: JSON.stringify(form.glasses_degree)
        }
    })
}
export function addSubscribe(data) {
    return request({
        url: '/web/user/addSubscribe',
        method: 'post',
        data: {
            user_name: data.username,
            mobile: data.phone,
            type: data.type,
            special: data.major
        }
    })
}
export function subscribeList(page) {
    return request({
        url: '/web/user/subscribeList',
        method: 'post',
        data: {
            // page: page
        }
    })
}
export function getIntentionInfor() {
    return request({
        url: '/web/other/university_intention',
        method: 'post',
        data: {}
    })
}
export function intentionInforEdit(form) {
    return request({
        url: '/web/other/university_intention_edit',
        method: 'post',
        data: {
            stu_id: form.stu_id,
            province: JSON.stringify(form.province),
            city: JSON.stringify(form.city),
            university_nature: JSON.stringify(form.university_nature),
            university_attribute: JSON.stringify(form.university_attribute),
            university_type: JSON.stringify(form.university_type),
            subject_type: JSON.stringify(form.subject_type),
            special_category: JSON.stringify(form.special_category),
            special: form.special,
            school: form.school,
            job: form.job,
            tuition: JSON.stringify(form.tuition)
        }
    })
}
export function getCityList() {
    return request({
        url: '/web/other/getCityList',
        method: 'post',
        data: {}
    })
}
export function saveArea(local_type_id, subject_name, year) {
    return request({
        url: '/web/other/saveArea',
        method: 'post',
        data: {
            area: localStorage.getItem('area'),
            local_type_id: local_type_id,
            subject_name: subject_name,
            year: year
        }
    })
}
export function addFav(form) {
    return request({
        url: '/web/other/add_fav',
        method: 'post',
        data: {
            stu_id: form.stu_id,
            fav_type: form.fav_type,
            data: form.data
        }
    })
}
export function delFav(form) {
    return request({
        url: '/web/other/del_fav',
        method: 'post',
        data: {
            stu_id: form.stu_id,
            fav_type: form.fav_type,
            data: form.data
        }
    })
}